// extracted by mini-css-extract-plugin
module.exports = {"btn":"_1P6IsBppMRtVIRZ09vt7Ts","icon":"_3Z3TK9Bm-FErSEc8sXGuPI"};